class Action {
  public isAction: boolean = true;
}
Action.prototype.isAction = true;
export default Action;
export { Action };
